import { SearchActionGA } from "@dafiti/core-layout";

export type SearchType = "type" | "click recent" | "click suggestion";

const ACTION_GA_KEY = "actionGA";

export function mapSearchActionToType(action: SearchActionGA): SearchType {
  const mapping: Record<SearchActionGA, SearchType> = {
    typeSearch: "type",
    clickSuggestionSearch: "click suggestion",
    clickRecent: "click recent",
  };

  return mapping[action];
}

export function getSearchAction(): SearchActionGA | null {
  if (typeof window === "undefined") return null;

  const action = sessionStorage.getItem(ACTION_GA_KEY);

  if (!action) return null;

  if (["typeSearch", "clickSuggestionSearch", "clickRecent"].includes(action)) {
    return action as SearchActionGA;
  }

  return null;
}

export function clearSearchAction(): void {
  if (typeof window === "undefined") return;

  sessionStorage.removeItem(ACTION_GA_KEY);
}
